<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">Home / blogs</div>
            <h1 class="text-3xl font-bold">Posts</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20 px-5">
      <div class="max-w-7xl mx-auto">
        <div>
          <div class="">
            <PostCardComponent :rows="rows" />
            <!-- <pre>
                {{ rows }}
            </pre> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed, onMounted } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import PostCardComponent from "@/components/PostCardComponent.vue";

const store = useStore();
const route = useRoute();
const rows = computed(() => store.getters["post/data"].rows);

onMounted(() => {
  document.title = "Blog - The Coral Database";
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", "Lates new and upates from the Coral Database");
});

store.dispatch("http/send", {
  module: "post",
});
</script>